import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'DOFbasen';

  constructor() {
  }
}



// WEBPACK FOOTER //
// /Users/Anders/workspace/DOFBasenCli/src/app/app.component.ts